import { render, staticRenderFns } from "./Proceedings.vue?vue&type=template&id=ba8cb94e&scoped=true"
import script from "./Proceedings.vue?vue&type=script&lang=js"
export * from "./Proceedings.vue?vue&type=script&lang=js"
import style0 from "./Proceedings.vue?vue&type=style&index=0&id=ba8cb94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8cb94e",
  null
  
)

export default component.exports